import { createRoutine } from "redux-saga-routines";

export const hospitalRoutine = createRoutine("API_HOSPITAL_GET");
export const hospitalStatusRoutine = createRoutine("API_HOSPITAL_STATUS");
export const hospitalAddRoutine = createRoutine("API_HOSPITAL_ADD");
